import { COMPONENT_TYPE as TYPE, LAYER_TYPE, COMPONENT_DISPLAY_NAME } from 'common/constants';
import { UNIFORM_PROPS } from 'common/constants/component-props';
import { generateElementId, generateNodeId } from 'utils/generate-id';
import View, { TimerType } from 'client/components/common/BuildingBlocks/Timer/Timer';

export const TIMER = () => {
	const _id = generateElementId();

	return {
		view: View,
		get model() {
			const type = TYPE.TIMER;

			return {
				_id,
				type,
				uiConfig: {
					layer: LAYER_TYPE.CONTENT,
					editorProps: {
						name: COMPONENT_DISPLAY_NAME[type],
						selectable: true,
						draggable: true,
						expandable: false,
						expanded: false,
					},
					nodeProps: {
						id: generateNodeId(_id, type),
					},
					componentProps: {
						[UNIFORM_PROPS.timerType]: TimerType.num,
						[UNIFORM_PROPS.timerTime]: 30,
						styles: {},
						other: {},
					},
				},
				children: [],
			};
		},
	};
};
